(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!window.ReserveReviewsCore) {
    window.ReserveReviewsCore = {
      cache: new Map(),
      storagePrefix: 'ReserveReviewsCore:',

      key(endpoint, productId, suffix) {
        return `${endpoint.replace(/\/$/, '')}/${productId}/${suffix}`;
      },

      readStored(key) {
        try {
          const value = localStorage.getItem(`${this.storagePrefix}${key}`);
          if (!value) return null;
          console.debug('[Reviews Core] localStorage hit', key);
          return JSON.parse(value);
        } catch (error) {
          return null;
        }
      },

      writeStored(key, data) {
        try {
          const storageKey = `${this.storagePrefix}${key}`;
          const value = JSON.stringify(data);
          if (localStorage.getItem(storageKey) !== value) {
            localStorage.setItem(storageKey, value);
            console.debug('[Reviews Core] localStorage update', key);
          }
        } catch (error) {
          console.debug('[Reviews Core] localStorage unavailable', key);
        }
      },

      getStoredJson(key) {
        return this.readStored(key);
      },

      async getJson(key, url) {
        if (this.cache.has(key)) {
          console.debug('[Reviews Core] cache hit', key);
          return this.cache.get(key);
        }

        console.debug('[Reviews Core] fetch', key);
        const request = fetch(url, { headers: { Accept: 'application/json' } }).then((response) => {
          if (!response.ok) throw new Error('Reviews unavailable');
          return response.json();
        }).then((data) => {
          this.writeStored(key, data);
          this.cache.set(key, Promise.resolve(data));
          return data;
        });
        this.cache.set(key, request);
        return request;
      },

      getStatsKey(endpoint, productId) {
        return this.key(endpoint, productId, 'count');
      },

      getStats(endpoint, productId) {
        const cleanEndpoint = endpoint.replace(/\/$/, '');
        return this.getJson(this.getStatsKey(cleanEndpoint, productId), `${cleanEndpoint}/${productId}/count`);
      },

      getStoredStats(endpoint, productId) {
        return this.getStoredJson(this.getStatsKey(endpoint, productId));
      },

      getReviewsKey(endpoint, productId, limit) {
        return this.key(endpoint, productId, `reviews-${Number(limit || 10)}`);
      },

      getReviews(endpoint, productId, limit) {
        const cleanEndpoint = endpoint.replace(/\/$/, '');
        const reviewLimit = Number(limit || 10);
        return this.getJson(
          this.getReviewsKey(cleanEndpoint, productId, reviewLimit),
          `${cleanEndpoint}/${productId}?page=1&limit=${reviewLimit}`
        );
      },

      getStoredReviews(endpoint, productId, limit) {
        return this.getStoredJson(this.getReviewsKey(endpoint, productId, limit));
      },

      clearProduct(endpoint, productId) {
        const base = `${endpoint.replace(/\/$/, '')}/${productId}/`;
        this.cache.forEach((value, key) => {
          if (key.startsWith(base)) {
            this.cache.delete(key);
          }
        });
        try {
          Object.keys(localStorage).forEach((key) => {
            if (key.startsWith(`${this.storagePrefix}${base}`)) {
              localStorage.removeItem(key);
            }
          });
        } catch (error) {
          console.debug('[Reviews Core] localStorage clear skipped', base);
        }
      },

      updateText(element, value) {
        if (element && element.textContent !== value) {
          element.textContent = value;
        }
      },

      updateHtml(element, value) {
        if (element && element.innerHTML.trim() !== value.trim()) {
          element.innerHTML = value;
        }
      },

      updateAttr(element, name, value) {
        if (element && element.getAttribute(name) !== value) {
          element.setAttribute(name, value);
        }
      },

      updateClass(element, className, force) {
        if (element && element.classList.contains(className) !== force) {
          element.classList.toggle(className, force);
        }
      },
    };
  }

  class ReviewsCoreSection extends HTMLElement {
    connectedCallback() {
      this.endpoint = (this.dataset.endpoint || '/apps/reviews').replace(/\/$/, '');
      this.productId = this.dataset.productId;
      this.limit = Number(this.dataset.limit || 10);
      this.score = this.querySelector('[data-reviews-score]');
      this.based = this.querySelector('[data-reviews-based]');
      this.stars = this.querySelector('[data-reviews-stars]');
      this.bars = this.querySelector('[data-reviews-bars]');
      this.list = this.querySelector('[data-reviews-list]');
      this.pagination = this.querySelector('[data-reviews-pagination]');
      this.form = this.querySelector('[data-reviews-form]');
      this.message = this.querySelector('[data-reviews-message]');

      if (this.dataset.reviewSource === 'app' && this.productId) {
        this.loadReviews();
      }

      if (this.form) {
        this.form.addEventListener('submit', this.submitReview.bind(this));
      }
    }

    async loadReviews() {
      try {
        const storedStats = window.ReserveReviewsCore.getStoredStats(this.endpoint, this.productId);
        const storedReviewsData = window.ReserveReviewsCore.getStoredReviews(this.endpoint, this.productId, this.limit);
        if (storedReviewsData) {
          this.renderReviewsState(storedStats, storedReviewsData);
        } else if (storedStats) {
          this.renderSummary(storedStats, 0);
        }

        const [stats, reviewsData] = await Promise.all([
          window.ReserveReviewsCore.getStats(this.endpoint, this.productId),
          window.ReserveReviewsCore.getReviews(this.endpoint, this.productId, this.limit),
        ]);
        this.renderReviewsState(stats, reviewsData);
      } catch (error) {
        this.renderEmpty();
        this.setMessage('');
      }
    }

    renderReviewsState(stats, reviewsData) {
      const reviews = Array.isArray(reviewsData?.reviews) ? reviewsData.reviews : [];
      if (stats) {
        this.renderSummary(stats, reviews.length);
      } else if (reviews.length) {
        this.renderSummary(this.buildStats(reviews), reviews.length);
      }
      if (reviews.length) {
        this.renderReviews(reviews);
      } else if (this.dataset.reviewSource === 'app') {
        this.renderEmpty();
      }
    }

    buildStats(reviews) {
      const distribution = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      let sum = 0;
      reviews.forEach((review) => {
        const rating = Math.max(1, Math.min(5, Number(review.rating) || 0));
        if (rating) {
          distribution[rating] += 1;
          sum += rating;
        }
      });
      return {
        count: reviews.length,
        averageRating: reviews.length ? Math.round((sum / reviews.length) * 10) / 10 : 0,
        distribution,
      };
    }

    renderSummary(stats, fallbackCount) {
      const count = Number(stats.count ?? fallbackCount ?? 0);
      const average = Number(stats.averageRating || 0);
      const distribution = stats.distribution || {};
      if (this.score) {
        window.ReserveReviewsCore.updateText(this.score, average ? average.toFixed(1) : '0');
      }
      if (this.stars) {
        window.ReserveReviewsCore.updateAttr(this.stars, 'aria-label', `${average.toFixed(1)} out of 5 stars`);
        window.ReserveReviewsCore.updateHtml(this.stars, this.renderStars(Math.round(average)));
      }
      if (this.based) {
        window.ReserveReviewsCore.updateText(this.based, `Based on ${count} ${count === 1 ? 'review' : 'reviews'}`);
      }
      if (this.bars) {
        window.ReserveReviewsCore.updateHtml(this.bars, [5, 4, 3, 2, 1]
          .map((rating) => {
            const ratingCount = Number(distribution[String(rating)] ?? distribution[rating] ?? 0);
            const percent = count > 0 ? (ratingCount / count) * 100 : 0;
            return `
              <div class="bar-row">
                <span class="bar-lbl">${rating} star</span>
                <div class="bar-track">
                  <div class="bar-fill" style="--bar-width: ${percent}%; width: ${percent}%;"></div>
                </div>
                <span class="bar-ct">(${ratingCount})</span>
              </div>
            `;
          })
          .join(''));
      }
      this.updatePagination(count);
    }

    renderReviews(reviews) {
      if (!this.list) return;
      window.ReserveReviewsCore.updateHtml(this.list, reviews.map((review) => this.reviewTemplate(review)).join(''));
    }

    renderEmpty() {
      if (!this.list) return;
      window.ReserveReviewsCore.updateHtml(this.list, '<div class="reviews-empty">No reviews yet</div>');
      this.updatePagination(0);
    }

    reviewTemplate(review) {
      const name = this.escape(review.userName || 'Customer');
      const title = this.escape(review.title || '');
      const comment = this.escape(review.comment || '');
      const rating = Math.max(1, Math.min(5, Number(review.rating) || 0));
      const createdAt = review.createdAt ? this.escape(new Date(review.createdAt).toLocaleDateString()) : '';
      return `
        <article class="rev-card">
          <div class="rc-top">
            <div class="rc-avatar">${name.slice(0, 1).toUpperCase()}</div>
            <div>
              <div class="rc-name">${name}</div>
              <div class="rc-strs" aria-label="${rating} out of 5 stars">${this.renderStars(rating)}</div>
            </div>
          </div>
          ${title ? `<h3 class="rc-title">${title}</h3>` : ''}
          ${comment ? `<p class="rc-body">${comment}</p>` : ''}
          ${createdAt ? `<div class="rc-date">${createdAt}</div>` : ''}
        </article>
      `;
    }

    renderStars(rating) {
      return [1, 2, 3, 4, 5]
        .map((index) => `<span class="star${index > rating ? ' star--empty' : ''}"></span>`)
        .join('');
    }

    updatePagination(count) {
      if (!this.pagination) return;
      window.ReserveReviewsCore.updateClass(this.pagination, 'pagination--hidden', Number(count || 0) <= 10);
    }

    async submitReview(event) {
      event.preventDefault();
      const formData = new FormData(this.form);
      const payload = {
        productId: String(this.productId),
        userName: String(formData.get('userName') || '').trim(),
        email: String(formData.get('email') || '').trim(),
        rating: Number(formData.get('rating')),
        title: String(formData.get('title') || '').trim(),
        comment: String(formData.get('comment') || '').trim(),
      };
      try {
        const response = await fetch(`${this.endpoint}/submit`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        if (response.status !== 201) {
          throw new Error('Review could not be submitted.');
        }
        window.ReserveReviewsCore.clearProduct(this.endpoint, this.productId);
        this.form.reset();
        this.setMessage(this.dataset.successMessage || 'Thank you. Your review is pending approval.');
      } catch (error) {
        this.setMessage(error.message || 'Review could not be submitted.');
      }
    }

    setMessage(text) {
      if (this.message) {
        window.ReserveReviewsCore.updateText(this.message, text);
      }
    }

    escape(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }
  }

  if (!customElements.get('reviews-core-section')) {
    customElements.define('reviews-core-section', ReviewsCoreSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-product-section"] && !Shopify.designMode) return;
  try {
    
  if (!window.ReserveReviewsCore) {
    window.ReserveReviewsCore = {
      cache: new Map(),
      storagePrefix: 'ReserveReviewsCore:',

      key(endpoint, productId, suffix) {
        return `${endpoint.replace(/\/$/, '')}/${productId}/${suffix}`;
      },

      readStored(key) {
        try {
          const value = localStorage.getItem(`${this.storagePrefix}${key}`);
          if (!value) return null;
          console.debug('[Reviews Core] localStorage hit', key);
          return JSON.parse(value);
        } catch (error) {
          return null;
        }
      },

      writeStored(key, data) {
        try {
          const storageKey = `${this.storagePrefix}${key}`;
          const value = JSON.stringify(data);
          if (localStorage.getItem(storageKey) !== value) {
            localStorage.setItem(storageKey, value);
            console.debug('[Reviews Core] localStorage update', key);
          }
        } catch (error) {
          console.debug('[Reviews Core] localStorage unavailable', key);
        }
      },

      getStoredJson(key) {
        return this.readStored(key);
      },

      async getJson(key, url) {
        if (this.cache.has(key)) {
          console.debug('[Reviews Core] cache hit', key);
          return this.cache.get(key);
        }

        console.debug('[Reviews Core] fetch', key);
        const request = fetch(url, { headers: { Accept: 'application/json' } }).then((response) => {
          if (!response.ok) throw new Error('Reviews unavailable');
          return response.json();
        }).then((data) => {
          this.writeStored(key, data);
          this.cache.set(key, Promise.resolve(data));
          return data;
        });
        this.cache.set(key, request);
        return request;
      },

      getStatsKey(endpoint, productId) {
        return this.key(endpoint, productId, 'count');
      },

      getStats(endpoint, productId) {
        const cleanEndpoint = endpoint.replace(/\/$/, '');
        return this.getJson(this.getStatsKey(cleanEndpoint, productId), `${cleanEndpoint}/${productId}/count`);
      },

      getStoredStats(endpoint, productId) {
        return this.getStoredJson(this.getStatsKey(endpoint, productId));
      },

      getReviewsKey(endpoint, productId, limit) {
        return this.key(endpoint, productId, `reviews-${Number(limit || 10)}`);
      },

      getReviews(endpoint, productId, limit) {
        const cleanEndpoint = endpoint.replace(/\/$/, '');
        const reviewLimit = Number(limit || 10);
        return this.getJson(
          this.getReviewsKey(cleanEndpoint, productId, reviewLimit),
          `${cleanEndpoint}/${productId}?page=1&limit=${reviewLimit}`
        );
      },

      getStoredReviews(endpoint, productId, limit) {
        return this.getStoredJson(this.getReviewsKey(endpoint, productId, limit));
      },

      clearProduct(endpoint, productId) {
        const base = `${endpoint.replace(/\/$/, '')}/${productId}/`;
        this.cache.forEach((value, key) => {
          if (key.startsWith(base)) {
            this.cache.delete(key);
          }
        });
        try {
          Object.keys(localStorage).forEach((key) => {
            if (key.startsWith(`${this.storagePrefix}${base}`)) {
              localStorage.removeItem(key);
            }
          });
        } catch (error) {
          console.debug('[Reviews Core] localStorage clear skipped', base);
        }
      },

      updateText(element, value) {
        if (element && element.textContent !== value) {
          element.textContent = value;
        }
      },

      updateHtml(element, value) {
        if (element && element.innerHTML.trim() !== value.trim()) {
          element.innerHTML = value;
        }
      },

      updateAttr(element, name, value) {
        if (element && element.getAttribute(name) !== value) {
          element.setAttribute(name, value);
        }
      },

      updateClass(element, className, force) {
        if (element && element.classList.contains(className) !== force) {
          element.classList.toggle(className, force);
        }
      },
    };
  }

  class ReserveProductSection extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.thumbs = this.querySelectorAll('[data-rk-thumb]');
      this.mainImage = this.querySelector('.rk-main-image');
      this.zoomButton = this.querySelector('[data-rk-zoom-button]');
      this.variantOptions = this.querySelectorAll('[data-rk-variant-options] .var-opt input');
      this.variantSelects = this.querySelector('variant-selects');
      this.productData = this.readProductData();
      this.ratingBadges = this.querySelectorAll('[data-rk-rating-badge][data-source="app"]');
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => this.selectImage(thumb, index));
      });
      this.variantOptions.forEach((option) => {
        option.addEventListener('change', () => this.selectVariant(option));
      });
      this.ratingBadges.forEach((badge) => this.loadRatingBadge(badge));
      this.watchGalleryFloat();

      if (typeof subscribe !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data?.sectionId !== this.productInfo?.dataset.section) return;
          this.syncCustomVariantUI(event.data.variant);
        });
      }
    }

    disconnectedCallback() {
      this.variantChangeUnsubscriber?.();
      if (this.onGalleryFloat) {
        window.removeEventListener('scroll', this.onGalleryFloat);
        window.removeEventListener('resize', this.onGalleryFloat);
      }
      if (this.galleryFloatFrame) cancelAnimationFrame(this.galleryFloatFrame);
    }

    watchGalleryFloat() {
      this.gallery = this.querySelector('.product-media__sticky');
      if (!this.gallery) return;

      const update = () => {
        const styles = getComputedStyle(this.gallery);
        if (styles.position !== 'sticky') {
          this.gallery.classList.remove('is-floating');
          this.gallery.classList.remove('is-released');
          return;
        }
        const offset = parseFloat(styles.top);
        if (Number.isNaN(offset)) return;
        // Sitting exactly on its offset means floating. Above it the gallery is
        // still at rest, below it the column has already released it.
        const distance = this.gallery.getBoundingClientRect().top - offset;
        this.gallery.classList.toggle('is-floating', Math.abs(distance) < 1);
        this.gallery.classList.toggle('is-released', distance < -1);
      };

      this.onGalleryFloat = () => {
        if (this.galleryFloatFrame) return;
        this.galleryFloatFrame = requestAnimationFrame(() => {
          this.galleryFloatFrame = null;
          update();
        });
      };

      window.addEventListener('scroll', this.onGalleryFloat, { passive: true });
      window.addEventListener('resize', this.onGalleryFloat, { passive: true });
      update();
    }

    readProductData() {
      try {
        return JSON.parse(this.querySelector('[data-rk-product-json]')?.textContent || '{}');
      } catch (error) {
        return {};
      }
    }

    selectImage(thumb, index) {
      this.thumbs.forEach((item) => {
        item.classList.remove('active');
        item.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('active');
      thumb.setAttribute('aria-pressed', 'true');
      if (this.mainImage && thumb.dataset.fullImage) {
        this.mainImage.setAttribute('src', thumb.dataset.fullImage);
        this.mainImage.setAttribute('srcset', '');
        this.mainImage.setAttribute('alt', thumb.dataset.alt || '');
      }
      if (this.zoomButton && thumb.dataset.mediaId) {
        this.zoomButton.setAttribute('data-media-id', thumb.dataset.mediaId);
        const label = this.zoomButton.querySelector('.visually-hidden');
        if (label) {
          label.textContent = `Open media ${index + 1} in modal`;
        }
      }
    }

    selectVariant(option) {
      this.variantOptions.forEach((item) => {
        item.closest('.var-opt')?.classList.toggle('active', item === option);
      });
      this.syncShopifyVariantPicker(option.dataset.variantId);
    }

    syncShopifyVariantPicker(variantId) {
      if (!this.variantSelects) return;

      const variant = (this.productData.variants || []).find((item) => String(item.id) === String(variantId));
      if (!variant) return;

      const optionValues = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      const fieldsets = Array.from(this.variantSelects.querySelectorAll('fieldset.js'));
      const selects = Array.from(this.variantSelects.querySelectorAll('select'));

      if (fieldsets.length) {
        fieldsets.forEach((fieldset, index) => {
          const value = optionValues[index];
          if (!value) return;
          const input = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
            (candidate) => candidate.value === value
          );
          if (input) input.checked = true;
        });
        const lastInput = fieldsets[fieldsets.length - 1]?.querySelector('input[type="radio"]:checked');
        if (lastInput) lastInput.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      if (selects.length) {
        selects.forEach((select, index) => {
          const value = optionValues[index];
          if (!value) return;
          const option = Array.from(select.options).find((candidate) => candidate.value === value);
          if (option) select.value = option.value;
        });
        const lastSelect = selects[selects.length - 1];
        if (lastSelect) lastSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    syncCustomVariantUI(variant) {
      if (!variant) return;

      this.variantOptions.forEach((input) => {
        const isActive = String(input.dataset.variantId) === String(variant.id);
        input.checked = isActive;
        input.closest('.var-opt')?.classList.toggle('active', isActive);
      });

      const mediaId = variant.featured_media?.id;
      if (!mediaId) return;

      const thumb = this.querySelector(`[data-rk-thumb][data-media-id="${mediaId}"]`);
      if (!thumb) return;

      const index = Array.from(this.thumbs).indexOf(thumb);
      this.selectImage(thumb, index > -1 ? index : 0);
    }

    async loadRatingBadge(badge) {
      const endpoint = (badge.dataset.endpoint || '/apps/reviews').replace(/\/$/, '');
      const productId = badge.dataset.productId;
      const stars = badge.querySelector('[data-rk-rating-stars]');
      const text = badge.querySelector('[data-rk-rating-text]');
      if (!productId) return;

      try {
        const storedStats = window.ReserveReviewsCore.getStoredStats(endpoint, productId);
        if (storedStats) {
          this.renderRatingBadge(badge, storedStats);
        }
        const stats = await window.ReserveReviewsCore.getStats(endpoint, productId);
        this.renderRatingBadge(badge, stats);
      } catch (error) {
        if (text) {
          window.ReserveReviewsCore.updateText(text, '');
        }
      }
    }

    renderRatingBadge(badge, stats) {
      const stars = badge.querySelector('[data-rk-rating-stars]');
      const text = badge.querySelector('[data-rk-rating-text]');
      const count = Number(stats.count || 0);
      const average = Number(stats.averageRating || 0);
      if (stars) {
        window.ReserveReviewsCore.updateAttr(stars, 'aria-label', `${average.toFixed(1)} out of 5 stars`);
        window.ReserveReviewsCore.updateHtml(stars, this.renderRatingStars(Math.round(average)));
      }
      if (text) {
        window.ReserveReviewsCore.updateText(text, `${count} ${count === 1 ? 'review' : 'reviews'}`);
      }
    }

    renderRatingStars(rating) {
      return [1, 2, 3, 4, 5]
        .map((index) => `<span class="star${index > rating ? ' star--empty' : ''}"></span>`)
        .join('');
    }
  }

  if (!customElements.get('reserve-product-section')) {
    customElements.define('reserve-product-section', ReserveProductSection);
  }


  } catch(e) { console.error(e); }
})();
})();
